module.exports = __webpack_public_path__ + "img/286.99294387.png";